import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from 'src/app/services/http/http.service';
import { HelperService, DialogService, LanguageService } from 'src/app/services';
import { of as observableOf, Subscription, Subject, Observable } from 'rxjs';
import { Path } from '../../../utils/constant/paths';
import { tap, catchError } from 'rxjs/operators';
import * as moment from 'moment';
import * as _ from 'lodash';
import { of } from 'rxjs';

@Injectable({
  providedIn: "root"
})
export class CampaignsService {
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});
  private stepTwoResponse;
  private distributionInsertResponse = new Subject<void>();
  
  public setStepTwoResponse(data) {
    this.stepTwoResponse = _.cloneDeep(data);
  }

  public getStepTwoResponse() {
    return this.stepTwoResponse;
  }

  public resetStepTwoResponse() {
    this.stepTwoResponse = null;
  }

  constructor(
    private http: HttpService,
    private helper: HelperService,
    private dialogService: DialogService,
    private languageService: LanguageService,
  ) { }

  getList(data?: any) {
    return this.http.post(Path.CAMPAIGN_WIZARD.GET_LIST, data);
  }

  getStatus() {
    return this.http.post(Path.CAMPAIGN_WIZARD.GET_STATUS);
  }

  generateCouponFromWizard(data?: any) {
    return this.http.post(Path.CAMPAIGN_WIZARD.GENERATE_COUPON, data);
  }

  getDistributionPromo(distribution_id: number): Observable<any> {
    let data = {
      web_filter: {
        distribution_ids: [distribution_id],
        limit: 50,
        offset: 0
      }
    };
    return this.http.post(Path.DISTRIBUTION.DISTRIBUTION_PROMO, data);
  }

  getDistributionPromoDetailList(distribution_id?: number,distribution_promo_detail_ids?:number, campaign_id?:number,  key?: string): Observable<any> {
    let data = {
      web_filter: {
        distribution_ids: [distribution_id],
        campaign_id:[campaign_id], 
        distribution_promo_detail_id: [distribution_promo_detail_ids],
        limit: 50,
        offset: 0,
        keyword: key
      }
    };
    return this.http.post(Path.DISTRIBUTION.DISTRIBUTION_PROMO_DETAIL, data);
  }

  getDistributionPromoDetailMechanicList(distribution_id: number, distribution_promo_detail_ids?:number) {
    let data = {
      web_filter: {
        distribution_ids: [distribution_id],
        distribution_promo_detail_id: [distribution_promo_detail_ids],
        limit: 50,
        offset: 0
      }
    };
    return this.http.post(Path.DISTRIBUTION.DISTRIBUTION_PROMO_DETAIL_MECHANIC, data)

  }

  getDistributionPromoDetailSKUList(distribution_id: number,  distribution_promo_detail_ids?:number) {
    let data = {
      web_filter: {
        distribution_ids: [distribution_id],
        distribution_promo_detail_id: [distribution_promo_detail_ids],
        limit: 999999,
        offset: 0
      }
    };
    return this.http.post(Path.DISTRIBUTION.DISTRIBUTION_PROMO_DETAIL_SKU, data)

  }

  /*
  POST REQUEST
  */
  postCondition(data?: any): Observable<any> {
    // const url = "/dev/promo_condition/post";
    // const url = "/promo_condition/post";
    return this.http.post(Path.DISTRIBUTION.POST_PROMO_CONDITION, data);
  }

  generateCoupon(data: any) {
    return this.http.post(Path.CAMPAIGN_WIZARD.GENERATE_COUPON, data);
  }

  generateUserRecipientMapping(data: any) {
    return this.http.post(Path.CAMPAIGN_WIZARD.GENERATE_USER_RECIPIENT_MAPPING, data);
  }


  checkAvailableCoupon(data: any) {
    return this.http.post(Path.CAMPAIGN_WIZARD.CHECK_QUANTITY, data);
  }

  /*
  Validations
  */
  validateStepOne(formValues, stepper) {
    let loadingDialog = this.dialogService.loading();
    for (let key in formValues) {
      if (_.toLower(key).includes("date")) {
        formValues[key] = moment(formValues[key]).format("YYYY-MM-DD");
      }
    }
    this.helper.objectTrimmer(formValues);
    loadingDialog.close();
    stepper.next();
    stepper.selected.interacted = false;
  }

  getCampaignDetailsByName(name: string) {
    return this.http.get(Path.CAMPAIGNS.GET_DETAIL, {"campaign_name": name});
  }

  submitStepTwo(data): Observable<any> {
    return this.http.post(Path.DISTRIBUTION.INSERT, data);
  }

  validateDistributionName(name: string): Observable<any> {
    return this.http.post(Path.DISTRIBUTION.GET_DETAIL, { web_filter: { distribution_name: name } });
  }

  getCategories(data?: any) {
    return this.http.post(Path.CATEGORY.GET_LIST, data);
  }

  getWizardCategories(data?: any) {
    return this.http.post(Path.CATEGORY.GET_WIZARD_LIST, data);
  }

  getBrands(data?: any) {
    return this.http.post(Path.BRAND.GET_LIST, data);
  }

  getWizardBrands(data?: any) {
    return this.http.post(Path.BRAND.GET_WIZARD_LIST, data);
  }

  getItems(data?: any) {
    return this.http.post(Path.ITEM.GET_LIST, data);
  }

  getCountries(data?: any) {
    return this.http.post(Path.COUNTRY.GET_LIST, data);
    // dev note: publicised for patient registration module
    // return this.http.public_post(Path.COUNTRY.GET_LIST, { body: data });
  }

  getRegions(data?: any) {
    return this.http.post(Path.REGION.GET_LIST, data);
  }

  getProvinces(data?: any) {
    return this.http.post(Path.PROVINCE.GET_LIST, data);
    // dev note: publicised for patient registration module
    // return this.http.public_post(Path.PROVINCE.GET_LIST, { body: data });
  }

  getIndustries(data?: any) {
    return this.http.post(Path.INDUSTRY.GET_LIST, data);
  }

  getCities(data?: any) {
    return this.http.post(Path.CITY.GET_LIST, data);
  }

  getCitiesForDropdownComponent(data?: any) {
    return this.http.post(Path.CITY.GET_LIST_FOR_DROPDOWN, data);
    // dev note: publicised for patient registration module
    // return this.http.public_post(Path.CITY.GET_LIST_FOR_DROPDOWN, { body: data });
  }

  getChaintypes(data?: any) {
    return this.http.post(Path.CHAIN_TYPE.GET_LIST, data);
  }

  getChains(data?: any) {
    return this.http.post(Path.CHAIN.GET_LIST, data);
  }

  getBranches(data?: any) {
    return this.http.post(Path.BRANCH.GET_LIST, data);
  }

  getDistributions(data?: any) {
    return this.http.post(Path.DISTRIBUTION.GET_LIST, data);
  }

  getDistributionDetail(data?: any) {
    return this.http.post(Path.DISTRIBUTION.GET_DETAIL, data);
  }

  getWebUsers(data?: any) {
    return this.http.post(Path.WEB_USER.GET_LIST, data);
  }

  getUserGroups(allocationLevel, data?: any) {
    if(allocationLevel == 'one') {
      return this.http.post(Path.GROUP.GET_LIST_USER, data);
    }
    else {
      return this.http.post(Path.GROUP.GET_LIST_RECIPIENT, data);
    }
  }

  getUserRecipientGroups(data?: any) {
    return this.http.post(Path.GROUP.GET_LIST_USER_RECIPIENT, data);
  }

  downloadCouponsList(data?: any) {
    return this.http.post(Path.CAMPAIGN_WIZARD.DOWNLOAD_COUPONS_LIST, data);
  }

  getWebUserGroup(data?: any) {
    return this.http.post(Path.CAMPAIGN_WIZARD.GET_WEB_USER_GROUP_LIST, data);
  }

  getRecipientGroup(data?: any) {
    return this.http.post(Path.CAMPAIGN_WIZARD.GET_RECIPIENT_GROUP_LIST, data);
  }

  deleteDistribution(data?: any) {
    return this.http.post(Path.DISTRIBUTION.DELETE, data);
  } 
}
